// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__30-Gy","valueCheck":"Param_valueCheck__2in6K","valueCross":"Param_valueCross__hhlgE"};